import React from "react";
import Select from "react-select";

const OPTIONS = [
  { label: "Landing Pages", value: "page" },
  { label: "Overlay Popups", value: "overlay" },
  { label: "Hook Popups", value: "hook" },
  { label: "Sticky Bars", value: "bar" },
  { label: "Embeds", value: "inline" },
];

const RelatedTemplatesFormatFilter = ({
  basePath,
  selectedValues = [],
  preservedParams = {},
}) => {
  const selected = OPTIONS.filter((option) => selectedValues.includes(option.value));

  const navigateWithValues = (values) => {
    const params = new URLSearchParams();

    Object.keys(preservedParams || {}).forEach((key) => {
      const value = preservedParams[key];
      if (value === null || value === undefined || value === "") {
        return;
      }
      params.set(key, value);
    });

    values.forEach((value) => {
      params.append("related_cta_types[]", value);
    });

    const queryString = params.toString();
    window.location.href = queryString ? `${basePath}?${queryString}` : basePath;
  };

  return (
    <div style={{ minWidth: "280px", display: "inline-block", marginTop: "10px" }}>
      <Select
        isMulti
        options={OPTIONS}
        value={selected}
        placeholder="Campaign formats"
        closeMenuOnSelect={false}
        isClearable={false}
        components={{
          IndicatorSeparator: () => null,
          ClearIndicator: () => null,
          DropdownIndicator: () => null,
        }}
        styles={{
          control: (base) => ({
            ...base,
            border: "0",
            borderColor: "transparent",
            boxShadow: "none",
            minHeight: "40px",
            backgroundColor: "transparent",
            "&:hover": {
              border: "0",
              borderColor: "transparent",
            },
          }),
          placeholder: (base) => ({
            ...base,
            fontSize: "1.25rem",
          }),
          valueContainer: (base) => ({
            ...base,
            fontSize: "1.25rem",
          }),
          multiValueLabel: (base) => ({
            ...base,
            fontSize: "1.25rem",
            paddingRight: "8px",
          }),
          multiValue: (base) => ({
            ...base,
            backgroundColor: "#e2e8f0",
            margin: "0 6px 0 0",
            borderRadius: "4px",
          }),
          option: (base) => ({
            ...base,
            fontSize: "1.25rem",
          }),
          input: (base) => ({
            ...base,
            fontSize: "1.25rem",
          }),
        }}
        onChange={(nextSelected) => {
          const values = (nextSelected || []).map((option) => option.value);
          navigateWithValues(values);
        }}
      />
    </div>
  );
};

export default RelatedTemplatesFormatFilter;
